(function () {
  'use strict';

  var component = {
    template:'<hq-tools-lighting-header></hq-tools-lighting-header><hq-tools-lighting-wizard-bar></hq-tools-lighting-wizard-bar><div class="hq-lighting-step hq-lighting-step--kelvins"><hq-tools-lighting-title action="$ctrl.openModal()" small="true" translate-key="KELVINS"></hq-tools-lighting-title><hq-tools-lighting-modal close-modal="$ctrl.closeModal()" ng-if="$ctrl.active" translate-key="KELVINS_INFO_MODAL_CONTENT"></hq-tools-lighting-modal><div class="hq-lighting-step__content"><div class="hq-lighting-image-blending" data-ng-class="{noSlider: $ctrl.numberStep === 1}"><div style="background-image: url(\'/themes/mieux-consommer/images/eclairage/kelvins-neut-{{$ctrl.room}}.jpg\');"></div><div style="background-image: url(\'/themes/mieux-consommer/images/eclairage/kelvins-warm-{{$ctrl.room}}.jpg\');" ng-style="{ opacity: $ctrl.opacityWarm, }"></div><div style="background-image: url(\'/themes/mieux-consommer/images/eclairage/kelvins-cool-{{$ctrl.room}}.jpg\');" ng-style="{ opacity: $ctrl.opacityCool }"></div></div></div><div class="hq-lighting-slider__container"><div class="hq-lighting-slider hq-lighting-list"><hq-tools-lighting-kelvins-list-item ng-repeat="(key, option) in $ctrl.options" has-popular="$ctrl.hasPopular" option="option" key="key" value="$ctrl.value" class="hq-lighting-kelvins-list-item" on-change="$ctrl.onChange(value)"></hq-tools-lighting-kelvins-list-item></div></div><hq-tools-lighting-footer value="{{$ctrl.displayValue}}" min-value="{{$ctrl.displayMinValue}}" max-value="{{$ctrl.displayMaxValue}}" translate-key="VALIDATE" sref="end" lref="lumen" sticky="true"></hq-tools-lighting-footer></div>',
    controller: KelvinsController,
  };

  function KelvinsController(hqTLightingOptions, hqTLightingKelvins, $scope, $timeout) {
    'ngInject';

    var ctrl = this;
    ctrl.onSliderChange = setKelvins;

    ctrl.getMinValue = function () {
      var kelvinArray = hqTLightingOptions.kelvins;
      return kelvinArray && kelvinArray.length >= 1 && kelvinArray[0].minKelvin
        ? kelvinArray[0].minKelvin : hqTLightingKelvins.min;
    };

    ctrl.getMaxValue = function () {
      var kelvinArray = hqTLightingOptions.kelvins;
      return kelvinArray && kelvinArray.length >= 1 && kelvinArray[kelvinArray.length - 1].maxKelvin
        ? kelvinArray[kelvinArray.length - 1].maxKelvin : hqTLightingKelvins.min;
    };

    ctrl.initKelvin = function () {
      var i = 0;
      ctrl.active = false;
      ctrl.value = 0;
      ctrl.min = this.getMinValue();
      ctrl.max = this.getMaxValue();
      ctrl.options = hqTLightingOptions.kelvins;
      ctrl.room = hqTLightingOptions.roomSelection;
      ctrl.numberStep = hqTLightingOptions.kelvins.length;

      for (i; i < ctrl.options.length; i += 1) {
        if (ctrl.options[i] && ctrl.options[i].popular) {
          ctrl.value = i;
        }
      }
    };

    ctrl.onChange = function (value) {
      if (value >= 0 && value < hqTLightingOptions.kelvins.length) {
        ctrl.value = value;
        setKelvins();
      }
    };

    ctrl.openModal = function () {
      ctrl.active = true;
      $timeout(function () {
        $scope.$broadcast('focusOn', 'modal-close');
      });
    };

    ctrl.closeModal = function () {
      ctrl.active = false;
      $scope.$broadcast('focusOn', 'modal-open');
    };

    ctrl.initKelvin();
    setKelvins();

    function setKelvins() {
      var opacity = hqTLightingKelvins.convert(getAverageKelvin());
      var range = getKelvinRange();
      ctrl.hasPopular = hqTLightingOptions.kelvinsAsPopular;
      ctrl.opacityWarm = opacity.warm;
      ctrl.opacityCool = opacity.cool;
      ctrl.displayValue = getAverageKelvin();
      ctrl.displayMaxValue = range.max;
      ctrl.displayMinValue = range.min;
    }

    function getAverageKelvin() {
      var currentKelvinStep = hqTLightingOptions.kelvins.length > 1 ?
        hqTLightingOptions.kelvins[parseInt(ctrl.value, 10)] : hqTLightingOptions.kelvins[0];

      return (parseInt(currentKelvinStep.minKelvin, 10) +
        parseInt(currentKelvinStep.maxKelvin, 10)) / 2;
    }

    function getKelvinRange() {
      var currentKelvinStep = hqTLightingOptions.kelvins.length > 1 ?
        hqTLightingOptions.kelvins[parseInt(ctrl.value, 10)] : hqTLightingOptions.kelvins[0];

      return {
        max: currentKelvinStep.maxKelvin,
        min: currentKelvinStep.minKelvin
      };
    }
  }

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingStepKelvins', component);
}());
